import { render, staticRenderFns } from "./PigeanSupportPlot.vue?vue&type=template&id=24aa5a09&scoped=true&"
import script from "./PigeanSupportPlot.vue?vue&type=script&lang=js&"
export * from "./PigeanSupportPlot.vue?vue&type=script&lang=js&"
import style0 from "./PigeanSupportPlot.vue?vue&type=style&index=0&id=24aa5a09&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24aa5a09",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24aa5a09')) {
      api.createRecord('24aa5a09', component.options)
    } else {
      api.reload('24aa5a09', component.options)
    }
    module.hot.accept("./PigeanSupportPlot.vue?vue&type=template&id=24aa5a09&scoped=true&", function () {
      api.rerender('24aa5a09', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/PIGEAN/PigeanSupportPlot.vue"
export default component.exports